import { z } from "zod/v4";
import { insuranceNetworkValues } from "../InsuranceNetworks.js";
import { therapeuticActKindOrder, } from "../TherapeuticChoicesFees.js";
import { therapeuticMaterialCodeValues, } from "../materiaux.js";
const therapeuticActKindSchema = z.enum(therapeuticActKindOrder);
const insuranceNetworkSchema = z.enum(insuranceNetworkValues);
const therapeuticMaterialCodeSchema = z.enum(therapeuticMaterialCodeValues);
export const therapeuticChoiceActSchema = z.object({
    id: z.string().min(1),
    kind: therapeuticActKindSchema,
    ccamCode: z.string().trim().min(1, "Code CCAM requis"),
    patientLabel: z.string().trim().min(1, "Intitulé patient requis"),
    practitionerLabel: z.string().trim().min(1, "Intitulé praticien requis"),
    fees: z.string().trim().min(1, "Honoraires requis"),
    materialCode: therapeuticMaterialCodeSchema.nullable(),
});
export const therapeuticChoiceCombinationSchema = z.object({
    id: z.string().min(1),
    acts: z
        .array(therapeuticChoiceActSchema)
        .min(1, "Au moins un acte est requis"),
});
export const therapeuticChoiceRowSchema = z
    .array(therapeuticChoiceCombinationSchema)
    .max(3, "Pas plus de trois choix par ligne");
export const therapeuticChoiceRowSettingsSchema = z.object({
    crown_incisor_canine_first_premolar: therapeuticChoiceRowSchema,
    crown_second_premolar: therapeuticChoiceRowSchema,
    crown_molar: therapeuticChoiceRowSchema,
    tooth_supported_bridge: therapeuticChoiceRowSchema,
    implant_crown: therapeuticChoiceRowSchema,
});
export const therapeuticChoicesFeesSettingsSchema = z.object({
    defaultRows: therapeuticChoiceRowSettingsSchema,
    networkRows: z.partialRecord(insuranceNetworkSchema, therapeuticChoiceRowSettingsSchema),
});
export const therapeuticChoicesFeesSaveInputSchema = therapeuticChoicesFeesSettingsSchema;
//# sourceMappingURL=TherapeuticChoicesFeesSchemas.js.map